import { SERVICE_WORKER_MESSAGE_TIMEOUT } from '@hkm/features/app/features/manifest/bus/constants';
import { SERVICE_WORKER } from '@hkm/serviceWorkerRegistration';

export async function postMessageToServiceWorker<TResponse>(
  message: { type: string } & Record<string, unknown>,
  timeout: number = SERVICE_WORKER_MESSAGE_TIMEOUT
): Promise<TResponse | undefined> {
  const registration =
    await navigator.serviceWorker?.getRegistration(SERVICE_WORKER);

  if (!registration?.active) return undefined;

  return new Promise((resolve) => {
    const timer = setTimeout(() => resolve(undefined), timeout);
    const channel = new MessageChannel();
    channel.port1.onmessage = (event: MessageEvent): void => {
      clearTimeout(timer);
      resolve(event.data as TResponse);
    };
    registration.active?.postMessage(message, [channel.port2]);
  });
}
